import { Navigate, useLocation } from "react-router-dom";
import { hasValidAuthToken } from "../../utils/authUtils";

export const ProtectedRoute = ({ redirectPath = "/login", children }) => {
  const location = useLocation();
  const isAuthenticated = hasValidAuthToken();

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  return children;
};
